import ProjectSaleOfferSelector from './ProjectSaleOfferSelector/ProjectSaleOfferSelector'
import SaleOfferAmount from './SaleOfferAmount/SaleOfferAmount'
import SaleOfferBooleanFlag from './SaleOfferBooleanFlag/SaleOfferBooleanFlag'
import SaleOfferClientUserEmail from './SaleOfferClientUserEmail/SaleOfferClientUserEmail'
import SaleOfferCurrency from './SaleOfferCurrency/SaleOfferCurrency'
import SaleOfferExpirationDate from './SaleOfferExpirationDate/SaleOfferExpirationDate'
import SaleOfferGroupSelector from './SaleOfferGroupSelector/SaleOfferGroupSelector'
import SaleOfferIntroText from './SaleOfferIntroText/SaleOfferIntroText'
import SaleOfferLanguageSelector from './SaleOfferLanguageSelector/SaleOfferLanguageSelector'
import SaleOfferPricePerUnit from './SaleOfferPricePerUnit/SaleOfferPricePerUnit'

export const offersForm = {
  ProjectSaleOfferSelector,
  SaleOfferAmount,
  SaleOfferBooleanFlag,
  SaleOfferClientUserEmail,
  SaleOfferCurrency,
  SaleOfferExpirationDate,
  SaleOfferGroupSelector,
  SaleOfferIntroText,
  SaleOfferLanguageSelector,
  SaleOfferPricePerUnit,
}
